import { List } from 'immutable';
import { ItemHelper } from './Item';
import { managerMessages } from './managerMessages';
import { ItemType } from './ItemType';
export const NonSequencedFlowItemHelper = {
    build: ({ parentId, trackingIdentifier, startingMessageId, id, ...props }) => {
        var _a, _b, _c, _d;
        return ({
            ...ItemHelper.build({ type: ItemType.NonSequencedFlow, id, trackingIdentifier, parentId }),
            title: (_a = props.title) !== null && _a !== void 0 ? _a : managerMessages.defaultTitleNonSequencedContent,
            isMandatory: (_b = props.isMandatory) !== null && _b !== void 0 ? _b : true,
            startingPosition: (_c = props.startingPosition) !== null && _c !== void 0 ? _c : null,
            startingMessageId,
            hotspots: (_d = props.hotspots) !== null && _d !== void 0 ? _d : List(),
        });
    },
};
